import React, { Component, PropTypes } from 'react';
import pick from 'lodash/pick';
import { SubmissionError } from 'redux-form';
import { Link } from 'react-router';
import classnames from 'classnames';
import { updateUserRequest } from 'common/ducks/user';
import RemoveAccountModal from 'account/components/remove_account_modal';
import InfoForm from 'account/components/info_form';
import { Meta } from 'common/components/meta';
import { isUsernameGenerated } from 'account/utils';
import {
  setMixpanelProfile, mixpanelProfileFromCsProfile
} from 'common/tracking';

// List of attributes of the form that should be sent to the server when submitting the account
// info form.
const ATTRIBUTES_TO_SAVE = [
  'id',
  'email',
  'username',
  'first_name',
  'last_name',
  'city',
  'state',
  'postal_code',
  'address_line_1',
  'address_line_2',
  'user_timezone',
  'primary_lang',
  'additional_lang_1',
  'country',
];

export default class Info extends Component {
  constructor(props) {
    super(props);

    this.state = {removing: false};
    this.showRemoveModal = this.showRemoveModal.bind(this);
    this.hideRemoveModal = this.hideRemoveModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      fetchLanguagesIfNeeded, fetchTimezonesIfNeeded, fetchCountriesIfNeeded, fetchIdPhotoIfNeeded,
      user
    } = this.props;

    fetchLanguagesIfNeeded();
    fetchTimezonesIfNeeded();
    fetchCountriesIfNeeded();

    if (user.profile_data.is_creative) {
      fetchIdPhotoIfNeeded(true);
    }
  }

  handleSubmit(formData) {
    return updateUserRequest(formData['id'], pick(formData, ATTRIBUTES_TO_SAVE))
      .then((res) => {
        setMixpanelProfile(res.data["email"], mixpanelProfileFromCsProfile(res.data));
        this.props.updateUserLocal(res.data);
      })
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      })
  }

  showRemoveModal() {
    this.setState({removing: true})
  }

  hideRemoveModal() {
    this.setState({removing: false})
  }

  render() {
    const { languages, timezones, countries, idValidated } = this.props;

    if (!languages || !timezones.length || !countries.length) {
      return null;
    }

    const userData = this.props.user.profile_data;
    /* only allow user to edit username if it was generated */
    const canEditUsername = isUsernameGenerated(userData.username);
    /* creatives can only edit their names if their IDs haven't been validated */
    const canEditName = !userData.is_creative || !idValidated;

    return (
      <div className="l-content account-info">
        <Meta title="Account Information" />
        <section id="content">
          <div className="row">
            <div className={classnames('small-16', 'columns')}>

              <InfoForm
                onSubmit={this.handleSubmit}
                timezones={this.props.timezones}
                countries={this.props.countries}
                initialValues={userData}
                canEditUsername={canEditUsername}
                canEditName={canEditName}
              />

              <div className="account-removal">
                <div className="row">
                  <div className="columns medium-8 large-6">
                    <h3 className="section-header">Delete Account</h3>
                    <p>
                      We'll be sad to see you go, so please don't. But if you must...
                      <a onClick={this.showRemoveModal}> Delete your account.</a>
                    </p>
                    <RemoveAccountModal showing={this.state.removing} user={this.props.user}
                      logout={this.props.logout} onClose={this.hideRemoveModal}/>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./account/components/info.jsx